<template>

    <section class="member-signup">

    <div class="row">

        <div class="col-xs-12">

            <div class="field-wrapper half">
                <label>{{ d.unionMember }}*</label>
                <div class="list-inline">
                    <label class="radio">
                        <input type="radio" name="union-member" required="true" v-model="values.unionmember" @change="onRadioUnionChange" value="ja">
                        <span class="checklabel">{{d.unionmemberyeslabel}}</span>
                        <span class="checkmark"></span>
                    </label>

                    <label class="radio">
                        <input type="radio" name="union-member" required="true" v-model="values.unionmember" @change="onRadioUnionChange" value="nej">
                        <span class="checklabel">{{d.unionmembernolabel}}</span>
                        <span class="checkmark"></span>
                    </label>
                </div>
                <div class="input-errors" v-for="error of v$.values.unionmember.$errors" :key="error.$uid">
                    <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">{{ d.errorunion }}</div>
                </div>
            </div>

        </div>

    </div>

    <div v-show="isUnsubscribeVisible" class="row">

        <div class="col-xs-12">

            <div class="field-wrapper half">
                <label>{{ d.unionUnsubscribe }}</label>
                <!-- DISCLAIMER HAS BEEN DISABLED FOR NOW -->
                <!-- <div class="disclaimer">{{ d.uniondisclaimer }}</div> -->
                <div class="list-inline">
                    <label class="radio">
                        <input type="radio" name="union-unsubscribe" required="true" v-model="values.unionunsubscribe" @change="onRadioUnsubscribeChange" value="ja">
                        <span class="checklabel">{{d.unionsubscribeyeslabel}}</span>
                        <span class="checkmark"></span>
                    </label>

                    <label class="radio">
                        <input type="radio" name="union-unsubscribe" required="true" v-model="values.unionunsubscribe" @change="onRadioUnsubscribeChange" value="nej">
                        <span class="checklabel">{{d.unionsubscribenolabel}}</span>
                        <span class="checkmark"></span>
                    </label>
                </div>
                <div class="input-errors" v-for="error of v$.values.unionunsubscribe.$errors" :key="error.$uid">
                    <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">{{ d.errorunion }}</div>
                </div>
            </div>

        </div>

    </div>

    <div v-show="isUnsubscribeDropdownVisible" class="row">

        <div class="col-xs-12">
            <!-- <DropDownWithSearch ref="educationInstitutionRef" id="educationInstitution" :label="d.educationInstitutionsTitle + '*'" @change="SetValue($event, 'educationInstitution')" :options="dictionaryEducationInstitutions" /> -->

            <DropDownWithSearch ref="dropdownRef" id="unionwhichone" :label="d.unionWhichOne + '*'" @change="SetValue($event, 'unionwhichone')" :options="dictionaryData"></DropDownWithSearch>
            <div class="input-errors no-margin" v-for="error of v$.values.unionwhichone.$errors" :key="error.$uid">
                <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">{{ d.errorcompanyname }}</div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <HelperTip :rte="d.helpertipunion"></HelperTip>
                </div>
            </div>

        </div>

    </div>

    </section>

</template>

<script>
    import axios from 'axios'
    import useVuelidate from '@vuelidate/core'
    import {  } from '@vuelidate/validators'

    import DropDownWithSearch from '../FormComponents/DropDownWithSearch.vue'
    import HelperTip from '../FormComponents/HelperTip.vue'
    import { cultureMixin } from '../../util/cultureMixin.js';
  
  export default {
    components: {
        DropDownWithSearch,
        HelperTip
    },
    mixins: [cultureMixin],
    setup () {
      // we use vuelidate for validation 
      // https://vuelidate-next.netlify.app/
      return { v$: useVuelidate({$lazy:true}) }
    },
    data: (instance) => {
        return {
            values: instance.store[instance.store.currentCulture].values.personalDetails,
            d: instance.store[instance.store.currentCulture].dictionary,
            culture: instance.store.currentCulture,

            isUnsubscribeVisible: false,
            isUnsubscribeDropdownVisible: false,

            dictionaryData: [],
            isLoading: false,
            error: null
        }
    },
    computed: {
        unionEndpoint(){
            return `/umbraco/api/signup/SearchUnions/?culture=${this.GetCulture()}&search=`;
        }
    },
    watch: {
      'values.unionmember'(value){
        if(value == "ja"){
            this.isUnsubscribeVisible = true;
        }else{
            this.isUnsubscribeVisible = false;
        }
      },
      'values.unionunsubscribe'(value){
        if(value == "ja"){
            this.isUnsubscribeDropdownVisible = true;
            this.v$.values.unionwhichone.$reset();
        }else{
            this.isUnsubscribeDropdownVisible = false;
        }
      }
    },
    methods: {
        async GetDictionaryData() {
            this.isLoading = true;
            this.error = null;

            try {
                const dataresponse = await axios.get(this.unionEndpoint);
                this.dictionaryData = dataresponse.data;

            } catch (error) {
                this.error = 'Der opstod en fejl under hentning af data:' + error.message;
                console.error(this.error);

            } finally {
                this.isLoading = false;

            }
        },
        merge(){
            console.log("merge called on unionDetails");
            //this.values.unionmember = "ja";
        },
        onRadioUnionChange() {
            if (this.values.unionmember != 'ja') {
                this.values.unionunsubscribe = '';
            }else{
                this.v$.values.unionunsubscribe.$reset();
            }
            this.emitter.emit('union-change');
        },
        onRadioUnsubscribeChange() {
            if (this.values.unionunsubscribe != 'ja') {
                this.values.unionwhichone = '';
                this.v$.values.unionwhichone.$reset();
            }
            this.emitter.emit('union-change');
        },
        SetValue(event, field) {
            switch (field) {
                case "unionwhichone":
                    this.values.unionwhichone = event.name;
                    this.emitter.emit('union-change');
                    break;
            }
        },
    },
    mounted() {
        this.GetDictionaryData();

        this.emitter.on('culture-change', () => {
            this.values = this.store[this.store.currentCulture].values.personalDetails;
            this.d = this.store[this.store.currentCulture].dictionary;
            this.v$.$reset()
        });

        if(this.merges){
            this.merge();
        }
    },
    validations() {
      return this.validations.unionDetails;
    }
  }
</script>

<style scoped lang="postcss">
.disclaimer{
    font-family: var(--font-it-ex);
    letter-spacing: var(--letter-spacing);
    margin-bottom: 10px;
}
</style>